export default __webpack_public_path__ + "static/media/shaw-blue.51fb60d5.png";